import React, { useEffect, useMemo } from 'react';
import Events from '../../events';
import { EventsType } from '../../events-types';
import { iBaseCardWithComponentProps, iBaseInnerCardProps } from '../types';
import { CardWithBaseComponent } from '../common/BaseCard';
import { renderField } from '../../utils/pair_entry';

const _DynamicCollectionCard: React.FC<iBaseInnerCardProps & { collectionName: string }> = ({
                                                                                                setIsShow,
                                                                                                setData,
                                                                                                data,
                                                                                                isActive,
                                                                                                collectionName,
                                                                                                setTitle
                                                                                            }) => {
    const UUID = useMemo(() => `_DynamicCollectionCard_${collectionName}`, [collectionName]);

    useEffect(() => {
        const handleOpenEvent = (event: { detail: any }) => {
            if (event?.detail) {
                setData?.(event.detail);
                setIsShow?.(true);
            }
        };

        Events.on(EventsType.OPEN_DYNAMIC_OBJECT, handleOpenEvent, UUID);

        return () => {
            Events.off(EventsType.OPEN_DYNAMIC_OBJECT, UUID);
        };
    }, [UUID, setData, setIsShow]);

    return (
        <div>
            {data && typeof data === 'object' &&
                Object.entries(data)
                    .filter(([key, _]) => !key.startsWith('_'))
                    .map(([key, _]) => (
                    <React.Fragment key={key}>{renderField(data, key)}</React.Fragment>
                ))}
        </div>
    );
};

const DynamicCollectionCard: React.FC<
    Omit<iBaseCardWithComponentProps, 'cardComponent'> & { collectionName: string }
> = ({ header, width, eventGroupToTrigger, collectionName }) => {
    return (
        <CardWithBaseComponent
            cardComponent={(props) => (
                <_DynamicCollectionCard {...props} collectionName={collectionName} />
            )}
            header={header ?? 'Details'}
            width={width}
            eventGroupToTrigger={eventGroupToTrigger}
        />
    );
};

export default React.memo(DynamicCollectionCard);
